import { BillCheckIcon, CardSearchIcon, EyeIcon } from '@solar-icons/vue/linear'
import type { Component } from 'vue'
import type { IconChipAccent } from '@/components/primitives/AppIconChip/icon-chip-types'
import type { DonutTone } from '@/components/charts/AppDonutChart/app-donut-chart-types'
import type { JourneyPhase } from '@/types/brand'

/** A journey phase's accent: one name that is at once an icon-chip accent and a donut tone. */
export type BeliefPhaseAccent = 'violet' | 'orange' | 'blue'

export const BELIEF_PHASE_ACCENT = {
  awareness: 'violet',
  consideration: 'orange',
  decision: 'blue',
} as const satisfies Record<JourneyPhase, BeliefPhaseAccent & IconChipAccent & DonutTone>

/** The background class that paints a phase accent. */
export const BELIEF_ACCENT_FILL: Record<BeliefPhaseAccent, string> = {
  violet: 'bg-accent-violet',
  orange: 'bg-accent-orange',
  blue: 'bg-accent-blue',
}

/** The soft ring colour class that halos a phase accent. */
export const BELIEF_ACCENT_RING: Record<BeliefPhaseAccent, string> = {
  violet: 'ring-accent-violet-soft',
  orange: 'ring-accent-orange-soft',
  blue: 'ring-accent-blue-soft',
}

export const BELIEF_PHASE_ICON: Record<JourneyPhase, Component> = {
  awareness: EyeIcon,
  consideration: CardSearchIcon,
  decision: BillCheckIcon,
}
